'use es6';

export const titlecase = string => string.replace(/(?:^|\s|-)\S/g, a => a.toUpperCase());